import React from 'react';
import NeonNFTLanding from './pages/NeonNFTLanding'; 
import './App.css'; 

function App() {
  return (
    <div className="App">
      <NeonNFTLanding />
    </div>
  );
}

export default App;